import { useState, useEffect, useLayoutEffect } from 'react'
import { SeaIntro } from '@/components/SeaIntro'

// Layout effect di client, effect biasa di server (hindari warning SSR)
const useIsoLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect

export function IntroGate() {
  const [show, setShow] = useState(false)

  // Jalan sebelum browser paint → intro langsung menutupi dashboard, tanpa kedip
  useIsoLayoutEffect(() => {
    if (sessionStorage.getItem('jal_play_intro')) {
      sessionStorage.removeItem('jal_play_intro')
      setShow(true)
    }
  }, [])

  if (!show) return null
  return (
    <SeaIntro
      onExit={() => document.documentElement.classList.remove('jal-intro')}
      onDone={() => setShow(false)}
    />
  )
}
